const css = `.radio-button-group {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: var(--space-5);
}
.radio-button-group.radio-button-group-vertical {
  padding: 0;
  padding-left: 12px;
}
.radio-button-group.radio-button-group-vertical .radio-options {
  flex-direction: column;
  gap: 8px;
}
.radio-button-group .radio-options {
  display: flex;
  gap: 32px;
  justify-content: center;
}
.radio-button-group .radio-options .radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
}
.radio-button-group .radio-options .radio-option.radio-option-disabled {
  opacity: 0.5;
}
.radio-button-group .radio-options .radio-option label {
  font-weight: var(--font-weight-regular);
  color: var(--text-muted);
}
.radio-button-group .field-error {
  left: 50% !important;
  top: 44px !important;
  transform: translateX(-50%);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvUmFkaW9CdXR0b25Hcm91cCIsInNvdXJjZXMiOlsiUmFkaW9CdXR0b25Hcm91cC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBOztBQUlKO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBOztBQUtOO0VBQ0U7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLnJhZGlvLWJ1dHRvbi1ncm91cCB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgZ2FwOiA4cHg7XG4gIHBhZGRpbmc6IHZhcigtLXNwYWNlLTUpO1xuXG4gICYucmFkaW8tYnV0dG9uLWdyb3VwLXZlcnRpY2FsIHtcbiAgICBwYWRkaW5nOiAwO1xuICAgIHBhZGRpbmctbGVmdDogMTJweDtcbiAgICAucmFkaW8tb3B0aW9ucyB7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgZ2FwOiA4cHg7XG4gICAgfVxuICB9XG5cbiAgLnJhZGlvLW9wdGlvbnMge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZ2FwOiAzMnB4O1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuXG4gICAgLnJhZGlvLW9wdGlvbiB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIGdhcDogOHB4O1xuXG4gICAgICAmLnJhZGlvLW9wdGlvbi1kaXNhYmxlZCB7XG4gICAgICAgIG9wYWNpdHk6IDAuNTtcbiAgICAgIH1cblxuICAgICAgbGFiZWwge1xuICAgICAgICBmb250LXdlaWdodDogdmFyKC0tZm9udC13ZWlnaHQtcmVndWxhcik7XG4gICAgICAgIGNvbG9yOiB2YXIoLS10ZXh0LW11dGVkKTtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAuZmllbGQtZXJyb3Ige1xuICAgIGxlZnQ6IDUwJSAhaW1wb3J0YW50O1xuICAgIHRvcDogNDRweCAhaW1wb3J0YW50O1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgtNTAlKTtcbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
